import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-TNVLLQW',
        },
    },
    host: 'www.zalando-lounge.dk',
});
